
import React from 'react';

const Booking = () => {
  return (
    <section className="py-20 bg-olive-50">
      <div className="max-w-6xl mx-auto px-6 lg:px-8 text-center">
        <h2 className="text-4xl lg:text-5xl font-light text-stone-800 mb-8 leading-tight">
          Pronto para sua <span className="text-olive-600">escapada perfeita?</span>
        </h2>
        
        <p className="text-xl text-stone-600 mb-12 max-w-2xl mx-auto leading-relaxed">
          Reserve agora sua estadia em nossa casa de campo e desfrute de momentos únicos 
          de tranquilidade e conexão com a natureza.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Card de Hospedagem */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <div className="text-center mb-8">
              <div className="text-4xl font-light text-stone-800 mb-2">
                A partir de <span className="text-olive-600 font-normal">R$ 600</span>
              </div>
              <p className="text-stone-600">por diária (casa completa)</p>
              <p className="text-sm text-stone-500 mt-2">Capacidade para até 10 pessoas</p>
            </div>

            <a 
              href="https://www.airbnb.com.br/rooms/553742770278089580?adults=4&children=0&infants=0&pets=0&wishlist_item_id=11001891367868&source_impression_id=p3_1760814757_P3Fwo7oINHF-zbvZ&previous_page_section_name=1000"
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-olive-600 text-white py-4 px-6 rounded-xl font-medium hover:bg-olive-700 transition-colors duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              Reserve Aqui
            </a>

            <div className="mt-6 p-4 bg-stone-50 rounded-xl">
              <h4 className="font-medium text-stone-800 mb-3">Informações importantes:</h4>
              <ul className="space-y-2 text-sm text-stone-600 text-left">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Check-in e check-out flexíveis
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Mínimo de 2 diárias
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Capacidade máxima: 10 pessoas
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Animais de estimação: consultar
                </li>
              </ul>
            </div>
          </div>

          {/* Card de Eventos/Day Use */}
          <div className="bg-white p-8 rounded-2xl shadow-xl">
            <div className="text-center mb-8">
              <div className="text-4xl font-light text-stone-800 mb-2">
                A partir de <span className="text-olive-600 font-normal">R$ 700</span>
              </div>
              <p className="text-stone-600">Day Use (até 30 pessoas)</p>
              <p className="text-sm text-stone-500 mt-2">Das 08h às 22h</p>
            </div>

            <a 
              href="https://wa.me/5545991110033?text=Olá! Gostaria de saber mais sobre o Day Use e eventos na casa de campo."
              target="_blank"
              rel="noopener noreferrer"
              className="w-full bg-olive-600 text-white py-4 px-6 rounded-xl font-medium hover:bg-olive-700 transition-colors duration-300 flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-calendar-check-line text-xl"></i>
              Reserve Aqui
            </a>

            <div className="mt-6 p-4 bg-stone-50 rounded-xl">
              <h4 className="font-medium text-stone-800 mb-3">Informações importantes:</h4>
              <ul className="space-y-2 text-sm text-stone-600 text-left">
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Disponível apenas de segunda a quinta
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Uso exclusivo do espaço gourmet
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Capacidade máxima: 30 pessoas
                </li>
                <li className="flex items-center gap-2">
                  <i className="ri-check-line text-olive-600"></i>
                  Horário: 08h às 22h
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-stone-600 mb-4">Tem dúvidas? Entre em contato conosco!</p>
          <a 
            href="https://wa.me/5545991110033?text=Olá! Gostaria de saber mais sobre a casa de campo e verificar disponibilidade."
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-green-600 hover:text-green-700 transition-colors duration-300 font-medium"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default Booking;
